var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',[_c('img',{attrs:{"src":require("@/assets/images/punto_red_icon_new.png"),"alt":"punto red logo"},on:{"click":_vm.expandSidebar}})])}
var staticRenderFns = []

export { render, staticRenderFns }